import { api } from "./client";

export interface Subscription {
  tier: string;
  status: string;
  currency: string;
  billing_interval: string;
  current_period_start: string | null;
  current_period_end: string | null;
  cancel_at_period_end: boolean;
  grace_period_until: string | null;
}

export interface MySubscriptionResponse {
  subscription: Subscription | null;
}

export interface PortalSessionResponse {
  url: string;
}

export async function getMySubscription(): Promise<MySubscriptionResponse> {
  const { data } = await api.get<MySubscriptionResponse>("/billing/my-subscription");
  return data;
}

export async function createPortalSession(): Promise<PortalSessionResponse> {
  const { data } = await api.post<PortalSessionResponse>("/billing/customer-portal-session");
  return data;
}
